export const EmptySearchIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="137"
		height="111"
		fill="none"
		viewBox="0 0 137 111"
	>
		<rect
			width="66"
			height="66"
			x="16.203"
			y="35.844"
			fill="#DAEBF7"
			rx="6"
			transform="rotate(-9.277 16.203 35.844)"
		></rect>
		<g clipPath="url(#clip0_2393_5345)">
			<path
				stroke="#93C0E0"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
				d="M50.331 17.572c-.166-.76.083-1.533.411-2.238.338-.724.451-1.52.279-2.31-.483-2.216-3.03-3.542-5.69-2.963-2.658.58-4.422 2.846-3.94 5.062.173.79.607 1.466 1.215 1.984.592.504 1.14 1.105 1.305 1.864v0a1.403 1.403 0 0 1-1.106 1.682q-4.534.851-9.048 1.3a106 106 0 0 1 2.963 10.354 1.436 1.436 0 0 1-1.099 1.725v0c-.76.166-1.534-.082-2.239-.41a3.6 3.6 0 0 0-2.31-.28c-2.215.483-3.541 3.03-2.962 5.69.58 2.659 2.846 4.423 5.062 3.94a3.6 3.6 0 0 0 1.984-1.214c.504-.593 1.104-1.14 1.864-1.306v0c.662-.144 1.308.3 1.404.97.529 3.722.854 7.433.984 11.12q5.007-.451 10.043-1.396a1.403 1.403 0 0 0 1.107-1.682v0c-.166-.76-.714-1.36-1.306-1.864a3.6 3.6 0 0 1-1.214-1.984c-.483-2.216 1.28-4.482 3.94-5.062 2.659-.58 5.206.747 5.689 2.963.172.79.059 1.586-.279 2.31-.328.705-.576 1.478-.41 2.238v0a1.266 1.266 0 0 0 1.575.955 105 105 0 0 0 11.32-3.877 105 105 0 0 0-.954-10.366 1.165 1.165 0 0 0-1.406-.97v0c-.76.165-1.36.713-1.864 1.305a3.6 3.6 0 0 1-1.984 1.214c-2.216.483-4.482-1.281-5.062-3.94-.58-2.66.747-5.206 2.963-5.69a3.6 3.6 0 0 1 2.31.28c.705.328 1.478.576 2.238.41v0a1.44 1.44 0 0 0 1.1-1.726c-.897-3.867-1.999-7.636-3.29-11.297a105 105 0 0 1-12.017 4.164 1.266 1.266 0 0 1-1.576-.955"
			></path>
		</g>
		<g clipPath="url(#clip1_2393_5345)">
			<path
				stroke="#93C0E0"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
				d="M90.14 65.674c.397-.668 1.108-1.063 1.83-1.354a3.6 3.6 0 0 0 1.78-1.496c1.161-1.948.208-4.657-2.13-6.05-2.338-1.394-5.174-.944-6.335 1.004-.414.694-.56 1.485-.47 2.278.089.773.079 1.586-.32 2.254v0a1.403 1.403 0 0 1-1.956.472 106 106 0 0 1-7.496-5.232 106 106 0 0 1-4.91 9.585 1.436 1.436 0 0 1-1.981.509v0c-.668-.398-1.064-1.108-1.354-1.83a3.6 3.6 0 0 0-1.496-1.781c-1.948-1.161-4.657-.208-6.05 2.13-1.394 2.338-.944 5.174 1.004 6.336a3.6 3.6 0 0 0 2.278.468c.773-.088 1.586-.078 2.254.32v0c.582.347.75 1.113.362 1.668a105 105 0 0 1-6.878 8.792 106 106 0 0 0 8.287 5.843 1.403 1.403 0 0 0 1.957-.472v0c.398-.668.408-1.481.32-2.254a3.6 3.6 0 0 1 .47-2.278c1.16-1.948 3.997-2.398 6.335-1.004 2.337 1.393 3.291 4.102 2.13 6.05a3.6 3.6 0 0 1-1.781 1.496c-.722.29-1.432.686-1.83 1.354v0a1.266 1.266 0 0 0 .499 1.774 105 105 0 0 0 10.915 4.902 105 105 0 0 0 6.384-8.221 1.165 1.165 0 0 0-.362-1.67v0c-.669-.398-1.481-.408-2.254-.32-.793.09-1.584-.055-2.278-.469-1.948-1.16-2.398-3.997-1.005-6.335s4.103-3.291 6.05-2.13a3.6 3.6 0 0 1 1.497 1.78c.29.723.685 1.432 1.354 1.83v0c.689.412 1.581.186 1.983-.508a106 106 0 0 0 5.314-10.498 105 105 0 0 1-11.62-5.17 1.266 1.266 0 0 1-.498-1.773"
			></path>
		</g>
		<g clipPath="url(#clip2_2393_5345)">
			<path
				stroke="#93C0E0"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
				d="M16.24 69.477c-.524-.181-.902-.62-1.21-1.08a2.57 2.57 0 0 0-1.3-1.026c-1.527-.528-3.278.529-3.912 2.36-.633 1.833.09 3.746 1.617 4.273a2.57 2.57 0 0 0 1.657-.002c.526-.173 1.094-.284 1.618-.103v0c.532.184.812.77.612 1.296a76 76 0 0 1-2.564 5.985 76 76 0 0 1 7.395 2.037c.542.18.828.769.641 1.308v0c-.18.524-.619.902-1.08 1.21a2.57 2.57 0 0 0-1.026 1.3c-.528 1.527.53 3.278 2.361 3.911 1.832.634 3.745-.09 4.273-1.617a2.57 2.57 0 0 0-.003-1.656c-.173-.526-.283-1.094-.102-1.618v0a.83.83 0 0 1 1.11-.494 75 75 0 0 1 7.127 3.525 75 75 0 0 0 2.876-6.625 1 1 0 0 0-.613-1.296v0c-.524-.181-1.092-.07-1.618.102a2.57 2.57 0 0 1-1.657.003c-1.526-.528-2.25-2.441-1.616-4.273s2.384-2.889 3.91-2.36a2.57 2.57 0 0 1 1.302 1.025c.307.461.685.9 1.209 1.08v0a.9.9 0 0 0 1.165-.604 75 75 0 0 0 1.84-8.321 75 75 0 0 0-6.658-3.264.83.83 0 0 0-1.111.495v0c-.181.523-.07 1.091.102 1.618.178.54.191 1.112.003 1.657-.528 1.526-2.441 2.25-4.273 1.616s-2.889-2.384-2.36-3.91a2.57 2.57 0 0 1 1.025-1.302c.461-.307.899-.685 1.08-1.209v0c.187-.54-.1-1.13-.642-1.31a76 76 0 0 0-8.09-2.187 75 75 0 0 1-1.924 8.851.9.9 0 0 1-1.164.605"
			></path>
		</g>
		<path
			stroke="#93C0E0"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="m128.875 56.875-14.074-14.074m0 0a20.25 20.25 0 0 0 5.949-14.364c0-11.218-9.094-20.312-20.312-20.312s-20.313 9.094-20.313 20.313 9.094 20.312 20.313 20.312a20.25 20.25 0 0 0 14.363-5.95"
		></path>
		<defs>
			<clipPath id="clip0_2393_5345">
				<path
					fill="#fff"
					d="M17 11.193 68.356 0 79.55 51.356 28.193 62.55z"
				></path>
			</clipPath>
			<clipPath id="clip1_2393_5345">
				<path
					fill="#fff"
					d="m70.158 38.244 45.15 26.912-26.913 45.15-45.15-26.913z"
				></path>
			</clipPath>
			<clipPath id="clip2_2393_5345">
				<path
					fill="#fff"
					d="M0 87.38 12.237 52l35.38 12.237-12.236 35.38z"
				></path>
			</clipPath>
		</defs>
	</svg>
);